<form nz-form class="form">
  <nz-tabset nzType="card">
    <nz-tab [nzTitle]="'A. THÔNG TIN CHUNG'">
      <div nz-row nzGutter="24">
        <div nz-col nzSm="24" nzMd="24" nzLg="4" nzXl="3" style="text-align: center;">
          <nz-form-item>
            <div class="form-group">
              <fieldset class="form-group">
                <label>Hình đại diện</label>
                <button ngClass="btnDelImg" nz-button nzType="primary" nzDanger (click)="removeImage()"
                  *ngIf="isImageSaved">Xóa</button>
                {{imageError}}
                <div class="custom-file fileInputProfileWrap">
                  <input type="file" (change)="fileChangeEvent($event)" class="fileInputProfile">
                  <div class="img-space">
                    <ng-container *ngIf="isImageSaved; else elseTemplate">
                      <img [src]="cardImageBase64" />
                    </ng-container>
                    <ng-template #elseTemplate>
                      <img src="./../../assets/img/noimg.jpg" class="img-responsive">
                    </ng-template>
                  </div>
                </div>
              </fieldset>
            </div>
          </nz-form-item>
        </div>
        <div nz-col nzSm="24" nzMd="24" nzLg="20" nzXl="21">
          <div nz-row nzGutter="24">
            <div nz-col nzSpan="8">
              <nz-form-item>
                <nz-form-label nzSpan="24">Mã định danh</nz-form-label>
                <nz-form-control nzSpan="24">
                  <input type="text" [(ngModel)]="student.studentCode" [ngModelOptions]="{standalone: true}" nz-input
                    placeholder="Nhập mã định danh" readonly />
                </nz-form-control>
              </nz-form-item>
            </div>
            <!-- <div nz-col nzSpan="8">
              <nz-form-item>
                <nz-form-label nzSpan="24">Mã định danh cấp Tỉnh</nz-form-label>
                <nz-form-control nzSpan="24">
                  <input type="text" [(ngModel)]="student.studentProvinceCode" [ngModelOptions]="{standalone: true}"
                    nz-input placeholder="Nhập mã định danh" />
                </nz-form-control>
              </nz-form-item>
            </div>
            <div nz-col nzSpan="8">
              <nz-form-item>
                <nz-form-label nzSpan="24">Mã định danh cấp Bộ</nz-form-label>
                <nz-form-control nzSpan="24">
                  <nz-input-group [nzSuffix]="suffixIconSearch">
                    <input type="text" [(ngModel)]="student.studentMinistryCode" (keyup.enter)="search()"
                      [ngModelOptions]="{standalone: true}" nz-input placeholder="Nhập mã định danh" />
                  </nz-input-group>
                  <ng-template #suffixIconSearch>
                    <i nz-icon nzType="search" (click)="search()" class="cursor-pointer"></i>
                  </ng-template>
                </nz-form-control>
              </nz-form-item>
            </div> -->
            <div nz-col nzSpan="8">
              <nz-form-item>
                <nz-form-label nzSpan="24" nzRequired #label nzFor="fullName">Họ và tên</nz-form-label>
                <nz-form-control nzSpan="24" nzErrorTip="Nhập trường thông tin bắt buộc"
                  [nzValidateStatus]="student.fullName ? '' : 'error'">
                  <input nz-input [jAutofocus] placeholder="Nhập họ tên..." required [(ngModel)]="student.fullName"
                    [ngModelOptions]="{standalone: true}">
                </nz-form-control>
              </nz-form-item>
            </div>
            <div nz-col nzSpan="8">
              <nz-form-item>
                <nz-form-label nzSpan="24" #label nzFor="yearOfBirth" nzNoColon>Ngày sinh</nz-form-label>
                <nz-form-control nzSpan="24" nzErrorTip="Vui lòng nhập năm"
                  [nzValidateStatus]="student.yearOfBirth ? '' : 'error'">
                  <nz-input-number nzPlaceHolder="Ngày" [(ngModel)]="student.dayOfBirth" [nzMin]="1" [nzMax]="31"
                    [nzStep]="1" class="date non-error widthcss" [ngModelOptions]="{standalone :true}"
                    (ngModelChange)="changeDateOfBirth()">
                  </nz-input-number>
                  <nz-form-label nzNoColon>/</nz-form-label>
                  <nz-input-number nzPlaceHolder="Tháng" [(ngModel)]="student.monthOfBirth" [nzMin]="1" [nzMax]="12"
                    [nzStep]="1" class="date non-error" [ngModelOptions]="{standalone :true}"
                    (ngModelChange)="changeDateOfBirth()"></nz-input-number>
                  <nz-form-label nzRequired nzNoColon>/</nz-form-label>
                  <nz-input-number nzPlaceHolder="Năm" [(ngModel)]="student.yearOfBirth" [nzMin]="1900"
                    [nzMax]="yearNow" [nzStep]="1" class="date" [ngModelOptions]="{standalone :true}"
                    (ngModelChange)="changeDateOfBirth()"></nz-input-number>
                </nz-form-control>
              </nz-form-item>
            </div>
            <div nz-col nzSpan="8">
              <nz-form-item>
                <nz-form-label nzSpan="24">Nơi sinh</nz-form-label>
                <nz-form-control nzSpan="24">
                <input nz-input [jAutofocus] placeholder="Nhập nơi sinh..."  [(ngModel)]="student.placeOfBirth"
                  [ngModelOptions]="{standalone: true}">
              </nz-form-control>
                <!-- <nz-form-control nzSpan="24">
                  <asc-autocomplete [ascModel]="noiSinhControl" (ascModelChange)="changeNoiSinh($event)"
                    [placeholder]="'Chọn nơi sinh'" [getListAC]="getNoiSinhACFn"></asc-autocomplete>
                </nz-form-control> -->
              </nz-form-item>
            </div>
            <div nz-col nzSpan="8">
              <nz-form-item>
                <nz-form-label nzSpan="24" nzRequired #label nzFor="gender">Giới tính:</nz-form-label>
                <nz-form-control nzSpan="24">
                  <nz-radio-group [(ngModel)]="student.gender" [ngModelOptions]="{standalone: true}">
                    <label nz-radio [nzValue]="1">Nam</label>
                    <label nz-radio [nzValue]="0">Nữ</label>
                    <label nz-radio [nzValue]="2">Khác</label>
                  </nz-radio-group>
                </nz-form-control>
              </nz-form-item>
            </div>
            <div nz-col nzSpan="8">
              <nz-form-item>
                <nz-form-label nzSpan="24" nzRequired #label nzFor="folkId">Dân tộc</nz-form-label>
                <nz-form-control nzErrorTip="Nhập trường thông tin bắt buộc"
                  [nzValidateStatus]="student.folkId ? '' : 'error'">
                  <asc-autocomplete [ascModel]="FolkControl" (ascModelChange)="changeFolk($event)"
                    [placeholder]="'Chọn dân tộc'" [getListAC]="getFolkACFn"></asc-autocomplete>
                </nz-form-control>
              </nz-form-item>
            </div>

            <ng-container *ngIf="isNoteFolk === true">
              <div nz-col nzSpan="8">
                <nz-form-item>
                  <nz-form-label nzSpan="24">Nhập dân tộc</nz-form-label>
                  <nz-form-control nzSpan="24">
                    <input nz-input placeholder="Nhập dân tộc..." [(ngModel)]="student.folk"
                      [ngModelOptions]="{standalone: true}">
                  </nz-form-control>
                </nz-form-item>
              </div>
            </ng-container>

            <div nz-col nzSpan="8">
              <nz-form-item>
                <nz-form-label nzSpan="24" nzRequired #label nzFor="nationalityId">Quốc tịch</nz-form-label>
                <nz-form-control nzSpan="24" nzErrorTip="Nhập trường thông tin bắt buộc"
                  [nzValidateStatus]="student.nationalityId ? '' : 'error'">
                  <asc-autocomplete required [ascModel]="natioNalityControl"
                    (ascModelChange)="changenatioNality($event)" [placeholder]="'Chọn quốc tịch'"
                    [getListAC]="getnatioNalityACFn">
                  </asc-autocomplete>
                </nz-form-control>
              </nz-form-item>
            </div>
          </div>
        </div>
      </div>
      <!--Thông tin liên lạc-->
      <nz-divider nzText="Thông tin liên lạc" nzOrientation="left"></nz-divider>
      <div nz-row nzGutter="24">
        <div nz-col nzSpan="8">
          <nz-form-item>
            <nz-form-label nzSpan="24" nzRequired #label nzFor="idNumber">CMND/CCCD/ĐDCD</nz-form-label>
            <nz-form-control [nzValidateStatus]="student.idNumber ? '' : 'error'" nzSpan="24" nzErrorTip="Nhập trường thông tin bắt buộc">
              <input nz-input placeholder="Nhấp số..." [(ngModel)]="student.idNumber" required
                [ngModelOptions]="{standalone: true}">
            </nz-form-control>
          </nz-form-item>
        </div>

        <div nz-col nzSpan="8">
          <nz-form-item>
            <nz-form-label nzSpan="24">Ngày cấp</nz-form-label>
            <nz-form-control nzSpan="24">
              <nz-date-picker [nzFormat]="'dd/MM/yyyy'" [(ngModel)]="student.idNumberDate"
                [ngModelOptions]="{standalone: true}">
              </nz-date-picker>
            </nz-form-control>
          </nz-form-item>
        </div>

        <div nz-col nzSpan="8">
          <nz-form-item>
            <nz-form-label nzSpan="24">Nơi cấp</nz-form-label>
            <nz-form-control nzSpan="24">
              <input nz-input placeholder="Nhập nơi cấp..." [(ngModel)]="student.issuedBy"
                [ngModelOptions]="{standalone: true}">
            </nz-form-control>
          </nz-form-item>
        </div>

        <div nz-col nzSpan="8">
          <nz-form-item>
            <nz-form-label nzSpan="24">Hộ chiếu</nz-form-label>
            <nz-form-control nzSpan="24">
              <input nz-input placeholder="Nhập hộ chiếu..." [(ngModel)]="student.passport"
                [ngModelOptions]="{standalone: true}">
            </nz-form-control>
          </nz-form-item>
        </div>

        <div nz-col nzSpan="8">
          <nz-form-item>
            <nz-form-label nzSpan="24">Số điện thoại</nz-form-label>
            <nz-form-control nzSpan="24">
              <input nz-input maxlength="15" placeholder="Nhập số điện thoại..." [(ngModel)]="student.phoneNumber"
                [ngModelOptions]="{standalone: true}">
            </nz-form-control>
          </nz-form-item>
        </div>
        <div nz-col nzSpan="8">
          <nz-form-item>
            <nz-form-label nzSpan="24">Email</nz-form-label>
            <nz-form-control nzSpan="24">
              <input nz-input maxlength="15" placeholder="Nhập email..." [(ngModel)]="student.email"
                [ngModelOptions]="{standalone: true}">
            </nz-form-control>
          </nz-form-item>
        </div>
        <div nz-col nzSpan="8"></div>
      </div>
      <nz-divider nzText="Địa chỉ nơi ở" nzOrientation="left"></nz-divider>
      <div nz-row nzGutter="24">
        <div nz-col nzSpan="8">
          <nz-form-item>
            <nz-form-label nzSpan="24" nzRequired #label nzFor="provinceId">Tỉnh thành</nz-form-label>
            <nz-form-control nzSpan="24" nzErrorTip="Nhập trường thông tin bắt buộc"
              [nzValidateStatus]="student.provinceId ? '' : 'error'">
              <asc-autocomplete [ascModel]="ProvinceControl" (ascModelChange)="changeProvince($event)"
                [placeholder]="'Chọn tỉnh thành'" [getListAC]="getProvinceACFn">
              </asc-autocomplete>
            </nz-form-control>
          </nz-form-item>
        </div>
        <div nz-col nzSpan="8">
          <nz-form-item>
            <nz-form-label nzSpan="24" nzRequired #label nzFor="districtId">Quận huyện</nz-form-label>
            <nz-form-control nzSpan="24" nzErrorTip="Nhập trường thông tin bắt buộc"
              [nzValidateStatus]="student.districtId ? '' : 'error'">
              <asc-autocomplete [ascModel]="DistrictControl" (ascModelChange)="changeDistrict($event)"
                [placeholder]="'Chọn quận huyện'" [getListAC]="getDistrictACFn">
              </asc-autocomplete>
            </nz-form-control>
          </nz-form-item>
        </div>
        <div nz-col nzSpan="8">
          <nz-form-item>
            <nz-form-label nzSpan="24">Phường xã</nz-form-label>
            <asc-autocomplete [ascModel]="WardControl" (ascModelChange)="changeWard($event)"
              [placeholder]="'Chọn phường xã'" [getListAC]="getWardACFn"></asc-autocomplete>
          </nz-form-item>
        </div>
      </div>

      <!--Thông tin người giám hộ-->
      <nz-divider nzText="Thông tin về người giám hộ" nzOrientation="left"></nz-divider>
      <div nz-row nzGutter="24">
        <div nz-col nzSpan="6">
          <nz-form-item>
            <nz-form-label nzSpan="24">Họ tên</nz-form-label>
            <nz-form-control nzSpan="24">
              <input nz-input placeholder="Nhập họ tên..." [(ngModel)]="student.tutorName"
                [ngModelOptions]="{standalone: true}">
            </nz-form-control>
          </nz-form-item>
        </div>
        <div nz-col nzSpan="6">
          <nz-form-item>
            <nz-form-label nzSpan="24">Năm sinh</nz-form-label>
            <nz-form-control nzSpan="24">
              <nz-input-number [(ngModel)]="student.tutorBirthYear" [nzMin]="1900" [nzMax]="yearNow" [nzStep]="1"
                nzPlaceHolder="Nhập năm..." [ngModelOptions]="{standalone :true}"></nz-input-number>
            </nz-form-control>
          </nz-form-item>
        </div>
        <div nz-col nzSpan="6">
          <nz-form-item>
            <nz-form-label nzSpan="24">Điện thoại</nz-form-label>
            <nz-form-control nzSpan="24">
              <input nz-input placeholder="Nhập SĐT..." [(ngModel)]="student.tutorPhone"
                [ngModelOptions]="{standalone: true}">
            </nz-form-control>
          </nz-form-item>
        </div>
        <div nz-col nzSpan="6">
          <nz-form-item>
            <nz-form-label nzSpan="24">Email</nz-form-label>
            <nz-form-control nzSpan="24">
              <input nz-input placeholder="Nhập email..." [(ngModel)]="student.tutorEmail"
                [ngModelOptions]="{standalone: true}">
            </nz-form-control>
          </nz-form-item>
        </div>
        <div nz-col nzSpan="6">
          <nz-form-item>
            <nz-form-label nzSpan="24">CMND/CCCD</nz-form-label>
            <nz-form-control nzSpan="24">
              <input nz-input placeholder="Nhập cmnd..." [(ngModel)]="student.tutorIDNumber"
                [ngModelOptions]="{standalone: true}">
            </nz-form-control>
          </nz-form-item>
        </div>
        <div nz-col nzSpan="6">
          <nz-form-item>
            <nz-form-label nzSpan="24">Hộ chiếu</nz-form-label>
            <nz-form-control nzSpan="24">
              <input nz-input placeholder="Nhập hộ chiếu..." [(ngModel)]="student.tutorPassport"
                [ngModelOptions]="{standalone: true}">
            </nz-form-control>
          </nz-form-item>
        </div>
        <div nz-col nzSpan="6">
          <nz-form-item>
            <nz-form-label nzSpan="24">Nghề nghiệp</nz-form-label>
            <nz-form-control nzSpan="24">
              <asc-autocomplete  [ascModel]="TutorCareersControl"
                (ascModelChange)="changeTutorCareers($event)" [placeholder]="'Chọn nghề nghiệp'"
                [getListAC]="getTutorCareersACFn">
              </asc-autocomplete>
            </nz-form-control>
          </nz-form-item>
        </div>
        <ng-container *ngIf="isNote === true">
          <div nz-col nzSpan="6">
            <nz-form-item>
              <nz-form-label nzSpan="24">Nhập cụ thể nghề nghiệp</nz-form-label>
              <nz-form-control nzSpan="24">
                <input nz-input placeholder="Nhập nghề nghiệp..." [(ngModel)]="student.tutorCareer"
                  [ngModelOptions]="{standalone: true}">
              </nz-form-control>
            </nz-form-item>
          </div>
        </ng-container>
        <!-- <div nz-col nzSpan="6">
          <nz-form-item>
            <nz-form-label nzSpan="24">Nghề nghiệp</nz-form-label>
            <nz-form-control nzSpan="24">
              <input nz-input placeholder="Nhập nghề..." [(ngModel)]="student.tutorCareer"
                [ngModelOptions]="{standalone: true}">
            </nz-form-control>
          </nz-form-item>
        </div> -->
        <!-- <div nz-col nzSpan="6">
          <nz-form-item>
            <nz-form-label nzSpan="24">Địa chỉ nơi ở</nz-form-label>
            <nz-form-control nzSpan="24">
              <input nz-input placeholder="Nhập địa chỉ..." [(ngModel)]="student.tutorAddress"
                [ngModelOptions]="{standalone: true}">
            </nz-form-control>
          </nz-form-item>
        </div> -->
        <div nz-col nzSpan="6">
          <nz-form-item>
            <nz-form-label nzSpan="24" nzRequired #label nzFor="tutorLivingConditionId">Điều kiện kinh tế gia đình
            </nz-form-label>
            <nz-form-control [nzValidateStatus]="student.tutorLivingConditionId ? '' : 'error'"
              nzErrorTip="Nhập trường thông tin bắt buộc">
              <asc-autocomplete [ascModel]="TutorLivingConditionControl"
                (ascModelChange)="changeTutorLivingCondition($event)" placeholder="Chọn hoàn cảnh..."
                [getListAC]="getTutorLivingConditionACFn">
              </asc-autocomplete>
            </nz-form-control>
          </nz-form-item>
        </div>
        <div nz-col nzSpan="6">
          <nz-form-item>
            <nz-form-label nzSpan="24">Trình độ</nz-form-label>
            <asc-autocomplete [ascModel]="TutorEducationLevelsControl"
              (ascModelChange)="changeTutorEducationLevels($event)" [placeholder]="'Chọn trình độ...'"
              [getListAC]="getTutorEducationLevelsACFn"></asc-autocomplete>
          </nz-form-item>
        </div>
        <div nz-col nzSpan="6">
          <nz-form-item>
            <nz-form-label nzSpan="24">Dân tộc</nz-form-label>
            <nz-form-control>
              <asc-autocomplete [ascModel]="tutorFolkControl" (ascModelChange)="changetutorFolk($event)"
                [placeholder]="'Chọn dân tộc'" [getListAC]="gettutorFolkACFn">
              </asc-autocomplete>
            </nz-form-control>
          </nz-form-item>
        </div>

        <ng-container *ngIf="isNoteTutorFolk === true">
          <div nz-col nzSpan="6">
            <nz-form-item>
              <nz-form-label nzSpan="24">Nhập dân tộc</nz-form-label>
              <nz-form-control nzSpan="24">
                <input nz-input placeholder="Nhập dân tộc..." [(ngModel)]="student.tutorFolk"
                  [ngModelOptions]="{standalone: true}">
              </nz-form-control>
            </nz-form-item>
          </div>
        </ng-container>

        <div nz-col [nzSpan]="6">
          <nz-form-item>
            <nz-form-label nzSpan="24">Mối quan hệ với người khuyết tật</nz-form-label>
            <nz-form-control nzErrorTip="Nhập trường thông tin bắt buộc">
              <asc-autocomplete [ascModel]="RelationshipControl" (ascModelChange)="changeRelationship($event)"
                [placeholder]="'Chọn mối quan hệ'" [getListAC]="getRelationshipACFn">
              </asc-autocomplete>
            </nz-form-control>
          </nz-form-item>
        </div>

        <ng-container *ngIf="isNoteRelationship === true">
          <div nz-col nzSpan="6">
            <nz-form-item>
              <nz-form-label nzSpan="24">Nhập cụ thể mối quan hệ với người khuyết tật</nz-form-label>
              <nz-form-control nzSpan="24">
                <input nz-input placeholder="Nhập mối quan hệ với người khuyết tật..." [(ngModel)]="student.tutorRelationship"
                  [ngModelOptions]="{standalone: true}">
              </nz-form-control>
            </nz-form-item>
          </div>
        </ng-container>

        <div nz-col nzSpan="24">
          <nz-form-item>
            <nz-form-label nzSpan="24">Bồi dưỡng về chăm sóc giáo dục người khuyết tật</nz-form-label>
            <nz-radio-group [ngModel]="student.tutorUnfostered" (ngModelChange)="tutorUnfosteredChange($event)"
              [ngModelOptions]="{standalone: true}">
              <label nz-radio [nzValue]="false">Chưa được bồi dưỡng</label>
              <label nz-radio [nzValue]="true">Đã được bồi dưỡng</label>
            </nz-radio-group>
            <label nz-checkbox [(ngModel)]="student.tutorCertificated" [nzDisabled]="!student.tutorUnfostered"
              [ngModelOptions]="{standalone: true}">Chứng nhận</label>
            <label nz-checkbox [(ngModel)]="student.tutorLicensed" [nzDisabled]="!student.tutorUnfostered"
              [ngModelOptions]="{standalone: true}">Chứng chỉ</label>
            <label nz-checkbox [(ngModel)]="student.tutorCD" [nzDisabled]="!student.tutorUnfostered"
              [ngModelOptions]="{standalone: true}">Cao đẳng</label>
            <label nz-checkbox [(ngModel)]="student.tutorDH" [nzDisabled]="!student.tutorUnfostered"
              [ngModelOptions]="{standalone: true}">Đại học</label>
            <label nz-checkbox [(ngModel)]="student.tutorSDH" [nzDisabled]="!student.tutorUnfostered"
              [ngModelOptions]="{standalone: true}">Sau đại học</label>
            <label nz-checkbox [(ngModel)]="student.tutorCNCC" [nzDisabled]="!student.tutorUnfostered"
              [ngModelOptions]="{standalone: true}">Đã được bồi dưỡng nhưng chưa có chứng nhận,chứng chỉ</label>
          </nz-form-item>
        </div>
      </div>
      <!-- Địa chỉ nơi ở NGH -->
      <nz-divider nzText="Địa chỉ nơi ở người giám hộ" nzOrientation="left"></nz-divider>
      <div nz-row nzGutter="24">
        <div nz-col nzSpan="8">
          <nz-form-item>
            <nz-form-label nzSpan="24">Tỉnh thành</nz-form-label>
            <nz-form-control nzSpan="24">
              <asc-autocomplete [ascModel]="TutorProvinceControl" (ascModelChange)="changeTutorProvince($event)"
                [placeholder]="'Chọn tỉnh thành'" [getListAC]="getTutorProvinceACFn">
              </asc-autocomplete>
            </nz-form-control>
          </nz-form-item>
        </div>
        <div nz-col nzSpan="8">
          <nz-form-item>
            <nz-form-label nzSpan="24" >Quận huyện</nz-form-label>
            <nz-form-control nzSpan="24">
              <asc-autocomplete [ascModel]="TutorDistrictControl" (ascModelChange)="changeTutorDistrict($event)"
                [placeholder]="'Chọn quận huyện'" [getListAC]="getTutorDistrictACFn">
              </asc-autocomplete>
            </nz-form-control>
          </nz-form-item>
        </div>
        <div nz-col nzSpan="8">
          <nz-form-item>
            <nz-form-label nzSpan="24">Phường xã</nz-form-label>
            <asc-autocomplete [ascModel]="TutorWardControl" (ascModelChange)="changeTutorWard($event)"
              [placeholder]="'Chọn phường xã'" [getListAC]="getTutorWardACFn"></asc-autocomplete>
          </nz-form-item>
        </div>
      </div>
      <!--Thông tin khuyết tật-->
      <nz-divider nzText="Thông tin về người khuyết tật" nzOrientation="left"></nz-divider>
      <div nz-row nzGutter="24">
        <div nz-col nzSpan="8">
          <nz-form-item>
            <nz-form-label nzRequired #label nzFor="disDisabilityCertificateType">Giấy chứng nhận KT</nz-form-label>
            <nz-form-control nzSpan="24">
              <nz-radio-group [(ngModel)]="student.disDisabilityCertificateType" (ngModelChange)="ngModelChange($event)" [ngModelOptions]="{standalone: true}">
                <label nz-radio [nzValue]="1">Chưa</label>
                <label nz-radio [nzValue]="0">Có</label>
              </nz-radio-group>
            </nz-form-control>
          </nz-form-item>
        </div>
        <ng-container *ngIf="isdisDisabilityCertificateType === 0">
          <div nz-col nzSpan="8">
            <nz-form-item>
              <nz-form-label nzSpan="24">Nhập giấy chứng nhận khuyết tật</nz-form-label>
              <nz-form-control nzSpan="24">
                <input nz-input placeholder="Nhập giấy chứng nhận khuyết tật..." [(ngModel)]="student.disabilityCertificate"
                  [ngModelOptions]="{standalone: true}">
              </nz-form-control>
            </nz-form-item>
          </div>
        </ng-container>
        <div nz-col nzSpan="8"></div>
        <div nz-col nzSpan="8">
          <nz-form-item>
            <nz-form-label nzSpan="24">Thời điểm cấp giấy chứng nhận khuyết tật</nz-form-label>
            <nz-form-control nzSpan="24">
              <nz-input-number nzPlaceHolder="Nhập năm..." [(ngModel)]="student.disDisabilityCertificateTypeInYear"
                [nzMin]="1900" [nzMax]="yearNow" [nzStep]="1" [ngModelOptions]="{standalone :true}"></nz-input-number>
            </nz-form-control>
          </nz-form-item>
        </div>
        <div nz-col nzSpan="8">
          <nz-form-item>
            <nz-form-label nzSpan="24">Thời điểm khuyết tật</nz-form-label>
            <nz-form-control nzSpan="24">
              <asc-autocomplete [ascModel]="thoiDiemKTControl" (ascModelChange)="changeThoiDiemKT($event)"
                [placeholder]="'Chọn thời điểm KT...'" [getListAC]="getThoiDiemKTACFn">
              </asc-autocomplete>
            </nz-form-control>
          </nz-form-item>
        </div>
        <div nz-col nzSpan="8">
          <nz-form-item>
            <nz-form-label nzSpan="24">Độ tuổi phát hiện khuyết tật</nz-form-label>
            <nz-form-control nzSpan="24">
              <nz-input-number [(ngModel)]="student.detectionYearOld" [ngModelOptions]="{standalone: true}"
                [nzPlaceHolder]="'Nhập độ tuổi'" [nzMax]='200' [nzMin]='0'></nz-input-number>
            </nz-form-control>
          </nz-form-item>
        </div>
        <div nz-col nzSpan="8">
          <nz-form-item>
            <nz-form-label nzSpan="24">Nguyên nhân</nz-form-label>
            <nz-form-control nzSpan="24">
              <asc-autocomplete [ascModel]="causesControl" (ascModelChange)="changeCauses($event)"
                placeholder="Chọn nguyên nhân..." [getListAC]="getCausesACFn">
              </asc-autocomplete>
            </nz-form-control>
          </nz-form-item>
        </div>
        <div nz-col nzSpan="8">
          <nz-form-item>
            <nz-form-label nzSpan="24" nzRequired #label nzFor="typeOfDisabilityId">Dạng tật</nz-form-label>
            <nz-form-control nzSpan="24" [nzValidateStatus]="student.typeOfDisabilityId ? '' : 'error'"
              nzErrorTip="Nhập trường thông tin bắt buộc">
              <asc-autocomplete [ascModel]="disTypeOfDisabilitysControl"
                (ascModelChange)="changeDisTypeOfDisabilitysACFn($event)" placeholder="Chọn dạng tật..."
                [getListAC]="getDisTypeOfDisabilitysACFn">
              </asc-autocomplete>
            </nz-form-control>
          </nz-form-item>
        </div>
        <ng-container *ngIf="isDisability === true">
          <div nz-col nzSpan="8">
            <nz-form-item>
              <nz-form-label nzSpan="24">Nhập dạng khuyết tật</nz-form-label>
              <nz-form-control nzSpan="24">
                <input nz-input placeholder="Nhập dạng khuyết tật..." [(ngModel)]="student.disability"
                  [ngModelOptions]="{standalone: true}">
              </nz-form-control>
            </nz-form-item>
          </div>
        </ng-container>
        <div nz-col nzSpan="8">
          <nz-form-item>
            <nz-form-label nzSpan="24" nzRequired #label nzFor="levelId">Mức độ khuyết tật</nz-form-label>
            <nz-form-control nzSpan="24" [nzValidateStatus]="student.levelId ? '' : 'error'"
              nzErrorTip="Nhập trường thông tin bắt buộc">
              <asc-autocomplete [ascModel]="LevelControl" (ascModelChange)="changeLevelACFn($event)"
                placeholder="Chọn mức độ khuyết tật..." [getListAC]="getLevelACFn">
              </asc-autocomplete>
            </nz-form-control>
          </nz-form-item>
        </div>
        <div nz-col nzSpan="24">
          <nz-form-item>
            <nz-form-label nzSpan="24" nzRequired #label nzFor="supportedEducation">Được hỗ trợ giáo dục</nz-form-label>
            <nz-form-control>
              <nz-radio-group [(ngModel)]="student.supportedEducation" [ngModelOptions]="{standalone: true}">
                <label nz-radio [nzValue]="false">Chưa</label>
                <label nz-radio [nzValue]="true">Có</label>
              </nz-radio-group>
            </nz-form-control>
          </nz-form-item>
        </div>
        <div nz-col nzSpan="24" class="pt-5">
          <div nz-row [nzGutter]="[24,0]">
            <div nz-col [nzSpan]="24">
              <nz-form-item>
                <nz-form-label nzSpan="24">Tình trạng giáo dục( Từ quá trình học tập)</nz-form-label>
              </nz-form-item>
            </div>
            <div nz-col [nzSpan]="24">
              <div nz-row [nzGutter]="[24,0]" *ngIf="hasStatusEducation">
                <div nz-col [nzSpan]="4">
                  <nz-form-item>
                    <nz-form-label [nzFor]="'field'" [nzNoColon]="true">
                      <i nz-icon nzType="check" nzTheme="outline"></i>&nbsp;{{ nameStatusEducation }}
                    </nz-form-label>
                  </nz-form-item>
                </div>
                <div nz-col [nzSpan]="10">
                  <nz-form-item>
                    <nz-form-label [nzFor]="'field'">
                      Cấp học/trình độ đào tạo
                    </nz-form-label>
                    <nz-form-control>
                      <asc-autocomplete [ascModel]="SchoolLevelControl" (ascModelChange)="changeSchoolLevel($event)"
                        placeholder="Chọn cấp học..." [disabled]="true" [getListAC]="getSchoolLevelACFn">
                      </asc-autocomplete>
                    </nz-form-control>
                  </nz-form-item>
                </div>
                <div nz-col [nzSpan]="10">
                  <nz-form-item>
                    <nz-form-label [nzFor]="'field'">
                      Lớp học năm học
                    </nz-form-label>
                    <nz-form-control>
                      <input nz-input [(ngModel)]="student.studyingClassYear" [disabled]="true"
                        [ngModelOptions]="{standalone :true}" />
                    </nz-form-control>
                  </nz-form-item>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div nz-col nzSpan="24">
          <nz-form-item>
            <nz-form-label nzSpan="24" [nzFor]="'interventioned'" nzRequired #label>Tình trạng can thiệp (đã hoặc đang
              can thiệp)</nz-form-label>
            <nz-form-control nzSpan="24" nzErrorTip="Nhập trường thông tin bắt buộc"
              [nzValidateStatus]="student.interventioned !== null ? '' : 'error'">
              <nz-radio-group [ngModel]="student.interventioned"
                (ngModelChange)="disDisabilityCertificateTypeChange($event)" [ngModelOptions]="{standalone: true}">
                <label nz-radio [nzValue]="false">Chưa</label>
                <label nz-radio [nzValue]="true">Có</label>
                <label *ngFor="let item of listStudentInterventionStatus" nz-checkbox [(ngModel)]="item.checked"
                  [nzDisabled]="!student.interventioned" [ngModelOptions]="{standalone: true}">{{item.label}}
                </label>
              </nz-radio-group>
            </nz-form-control>
          </nz-form-item>
        </div>
        <div nz-col nzSpan="8">
          <nz-form-item>
            <nz-form-label nzSpan="24" [nzFor]="'employmentStatusId'" nzRequired #label>Tình trạng việc làm
            </nz-form-label>
            <nz-form-control nzErrorTip="Nhập trường thông tin bắt buộc"
              [nzValidateStatus]="student.employmentStatusId ? '' : 'error'">
              <asc-autocomplete [ascModel]="EmploymentStatusControl" (ascModelChange)="changeEmploymentStatus($event)"
                [placeholder]="'Chọn tình trạng việc làm...'" [getListAC]="getEmploymentStatusACFn">
              </asc-autocomplete>
            </nz-form-control>
          </nz-form-item>
        </div>
        <div nz-col nzSpan="8">
          <nz-form-item>
            <nz-form-label nzSpan="24" [nzFor]="'maritalStatusId'" nzRequired #label>Tình trạng hôn nhân</nz-form-label>
            <nz-form-control nzErrorTip="Nhập trường thông tin bắt buộc"
              [nzValidateStatus]="student.maritalStatusId ? '' : 'error'">
              <asc-autocomplete [ascModel]="MaritalStatusControl" (ascModelChange)="changeMaritalStatus($event)"
                [placeholder]="'Chọn phương tình trạng hôn nhân...'" [getListAC]="getMaritalStatusACFn">
              </asc-autocomplete>
            </nz-form-control>
          </nz-form-item>
        </div>
        <div nz-col nzSpan="8">
          <nz-form-item>
            <nz-form-label nzSpan="24" [nzFor]="'caregiverId'" nzRequired #label>Đang sống tại</nz-form-label>
            <nz-form-control nzErrorTip="Nhập trường thông tin bắt buộc"
              [nzValidateStatus]="student.caregiverId ? '' : 'error'">
              <asc-autocomplete [ascModel]="CaregiverControl" (ascModelChange)="changeCaregiver($event)"
                [placeholder]="'Chọn đang sống tại...'" [getListAC]="getCaregiverACFn">
              </asc-autocomplete>
            </nz-form-control>
          </nz-form-item>
        </div>
        <ng-container *ngIf="isNoteCaregiver === true">
          <div nz-col nzSpan="6">
            <nz-form-item>
              <nz-form-label nzSpan="24">Nhập đang sống tại</nz-form-label>
              <nz-form-control nzSpan="24">
                <input nz-input placeholder="Nhập đang sống tại..." [(ngModel)]="student.caregiver"
                  [ngModelOptions]="{standalone: true}">
              </nz-form-control>
            </nz-form-item>
          </div>
        </ng-container>

      </div>
    </nz-tab>
    <!-- TAB B. THÔNG TIN VỀ MỨC ĐỘ PHÁT TRIỂN -->
    <nz-tab [nzTitle]="'B. THÔNG TIN VỀ MỨC ĐỘ PHÁT TRIỂN'">
      <div nz-row [nzGutter]="[24,12]" class="pl-8 pb-8">
        <nz-table #basicTable [nzData]="lstLevelOfDeDto" [nzShowPagination]="false" id="formLod">
          <thead>
            <tr>
              <th>Lĩnh vực</th>
              <th>Mức độ phát triển</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let data of basicTable.data ; index as i">
              <td><strong> {{i + 1}}. {{data.name}}</strong></td>
              <td>
                <nz-radio-group>
                  <label nz-radio [nzValue]="o.id" *ngFor="let o of data.details"
                    (click)="onChangeMdpt(data.id,o.id)">{{ o.name }}</label>
                </nz-radio-group>
              </td>
            </tr>
          </tbody>
        </nz-table>
      </div>
    </nz-tab>
    <nz-tab [nzTitle]="'C. NHU CẦU HỖ TRỢ GIÁO DỤC'">
      <div nz-row [nzGutter]="[24,24]">
        <div nz-col [nzSpan]="24">
          <div nz-row [nzGutter]="[0,24]" class="w-full">
            <ng-container *ngFor="let educationalSupports of listEducationalSupports; let i = index">
              <div nz-col [nzSpan]="24">
                <nz-form-item>
                  <nz-form-label [nzFor]="'field'" [nzNoColon]="true">
                    <label nz-checkbox [ngModel]="educationalSupports.checked"
                      (ngModelChange)="changeOneCheckES($event,i)"
                      [ngModelOptions]="{standalone: true}">{{educationalSupports.name}}</label>
                  </nz-form-label>
                </nz-form-item>
              </div>
              <ng-container *ngIf="educationalSupports.isEducationFacilitiesEquipment">
                <div nz-col [nzSpan]="24">
                  <nz-form-item>
                    <nz-form-label [nzFor]="'field'" [nzNoColon]="true">
                      <i class="fas fa-circle"></i>
                      Phương tiện hỗ trợ dành cho người khuyết tật
                    </nz-form-label>
                    <nz-form-control>
                      <nz-select [nzMaxTagCount]="5" [nzMaxTagPlaceholder]="tagPlaceHolder" nzMode="multiple" (ngModelChange)="changeValueFacilities($event)"
                        nzPlaceHolder="Chọn phương tiện, thiết bị"
                        [(ngModel)]="student.listStudentFacilitiesAndEquipmentNkt" [ngModelOptions]="{standalone: true}"
                        [nzDisabled]="!educationalSupports.checked">
                        <nz-option *ngFor="let item of listNeedForEducationalSp" [nzLabel]="item.name"
                          [nzValue]="item"></nz-option>
                      </nz-select>
                      <ng-template #tagPlaceHolder let-selectedList> và hơn {{ selectedList.length }} pt,tb khác
                      </ng-template>
                    </nz-form-control>
                  </nz-form-item>

                  <ng-container *ngIf="isNoteFacilities === true">
                    <div nz-col nzSpan="6">
                      <nz-form-item>
                        <nz-form-label nzSpan="24">Nhập phương tiện được hỗ trợ</nz-form-label>
                        <nz-form-control nzSpan="24">
                          <input nz-input placeholder="Nhập phương tiện được hỗ trợ..." [(ngModel)]="student.facilitiesAndEquipmentNkt"
                            [ngModelOptions]="{standalone: true}">
                        </nz-form-control>
                      </nz-form-item>
                    </div>
                  </ng-container>

                </div>
              </ng-container>
            </ng-container>
          </div>
        </div>
      </div>
    </nz-tab>
    <nz-tab [nzTitle]="'D. NHẬN THỨC CHÍNH SÁCH GIÁO DỤC CHO NGƯỜI KHUYẾT TẬT'">
      <div nz-row [nzGutter]="[24,24]">
        <div nz-col [nzSpan]="24">
          <div nz-row [nzGutter]="[0,24]" class="w-full">
            <div nz-col [nzSpan]="24">
              <nz-form-item>
                <nz-form-label nzRequired #label nzFor="understandDisabilityPolicy">
                  <b>1. Biết chính sách GD cho người khuyết tật</b>
                </nz-form-label>
                <nz-form-control>
                  <nz-radio-group [ngModel]="student.understandDisabilityPolicy"
                    (ngModelChange)="understandDisabilityPolicyChange($event)" [ngModelOptions]="{standalone :true}">
                    <label nz-radio [nzValue]="false">Chưa</label>
                    <label nz-radio [nzValue]="true">Có</label>
                  </nz-radio-group>
                </nz-form-control>
              </nz-form-item>
            </div>
            <ng-container *ngFor="let disabilityPolicy of listDisabilityPolicy; let i = index">
              <div nz-col [nzSpan]="12">
                <nz-form-item>
                  <nz-form-label [nzFor]="'field'" [nzNoColon]="true">
                    <label [nzTooltipTitle]="disabilityPolicy.name" nz-tooltip nz-checkbox
                      [ngModel]="disabilityPolicy.checked" (ngModelChange)="disabilityPolicyCheckedChange($event, i)"
                      [ngModelOptions]="{standalone :true}" [nzDisabled]="!student.understandDisabilityPolicy">{{
                      disabilityPolicy.name }}</label>
                  </nz-form-label>
                </nz-form-item>
              </div>
              <!-- <div nz-col [nzSpan]="24" *ngIf="disabilityPolicy.isRequiredNote">
                <nz-form-item>
                  <nz-form-label [nzFor]="'field'">
                    <i class="fas fa-circle"></i>
                    Nhập khi chọn loại "khác"
                  </nz-form-label>
                  <nz-form-control>
                    <input nz-input [(ngModel)]="student.disabilityPolicyNote" [ngModelOptions]="{standalone :true}" [disabled]="!this.listDisabilityPolicy[i].checked"/>
                  </nz-form-control>
                </nz-form-item>
              </div> -->
            </ng-container>
          </div>
        </div>
        <div nz-col [nzSpan]="24">
          <div nz-row [nzGutter]="[0,24]" class="w-full">
            <div nz-col [nzSpan]="24">
              <nz-form-item>
                <nz-form-label>
                  Tiếp nhận thông tin về các chính sách từ nguồn
                </nz-form-label>
              </nz-form-item>
            </div>
            <ng-container *ngFor="let informationSources of listInformationSources; let i = index">
              <div nz-col [nzSpan]="12">
                <nz-form-item>
                  <nz-form-label [nzFor]="'field'" [nzNoColon]="true">
                    <label nz-checkbox [ngModel]="informationSources.checked"
                      (ngModelChange)="changeOneCheckInformationSources($event,i)"
                      [ngModelOptions]="{standalone :true}">{{ informationSources.name }}</label>
                  </nz-form-label>
                </nz-form-item>
              </div>
              <!-- <div nz-col [nzSpan]="12" *ngIf="informationSources.isRequiredNote">
                <nz-form-item>
                  <nz-form-label [nzFor]="'field'">
                    <i class="fas fa-circle"></i>
                    Nhập khi chọn loại "khác"
                  </nz-form-label>
                  <nz-form-control>
                    <input nz-input [(ngModel)]="student.informationSourceNote" [ngModelOptions]="{standalone :true}" [disabled]="!this.listInformationSources[i].checked"/>
                  </nz-form-control>
                </nz-form-item>
              </div> -->
            </ng-container>
          </div>
        </div>
        <div nz-col [nzSpan]="24">
          <div nz-row>
            <div nz-col [nzSpan]="24">
              <nz-form-item>
                <nz-form-label [nzFor]="'field'">
                  <b>2. Sự phối hợp của cộng đồng trong thực hiện chính sách giáo dục người khuyết tật</b>
                </nz-form-label>
              </nz-form-item>
            </div>
            <div nz-col [nzSpan]="24">
              <nz-radio-group [(ngModel)]="student.communityCoordination" [ngModelOptions]="{standalone: true}">
                <div nz-row>
                  <div nz-col [nzSpan]="24">
                    <div nz-col [nzSpan]="24">
                      <nz-form-label [nzFor]="'field'" [nzNoColon]="true">
                        <label nz-radio [nzValue]="false">Chưa</label>
                      </nz-form-label>
                    </div>
                    <div nz-col [nzSpan]="24" class="flex">
                      <div>
                        <nz-form-label [nzFor]="'field'" [nzNoColon]="true">
                          <label nz-radio [nzValue]="true">Có (Mức độ):</label>
                        </nz-form-label>
                      </div>
                      <nz-radio-group [(ngModel)]="student.communityCoordinationId"
                        [ngModelOptions]="{standalone: true}">
                        <div nz-row>
                          <ng-container *ngFor="let publicCommunityCoordinations of listPublicCommunityCoordinations">
                            <div nz-col [nzSpan]="8">
                              <nz-form-item>
                                <nz-form-label [nzFor]="'field'" [nzNoColon]="true">
                                  <label nz-radio [nzValue]="publicCommunityCoordinations.value"
                                    [nzDisabled]="!student.communityCoordination">{{ publicCommunityCoordinations.name
                                    }}</label>
                                </nz-form-label>
                              </nz-form-item>
                            </div>
                          </ng-container>
                        </div>
                      </nz-radio-group>
                    </div>
                  </div>
                </div>
              </nz-radio-group>
            </div>
          </div>
        </div>
        <div nz-col [nzSpan]="24">
          <div nz-row>
            <div nz-col [nzSpan]="24">
              <nz-form-item>
                <nz-form-label [nzFor]="'field'">
                  <b>3. Sự phối hợp của chính quyền và ban ngành địa phương</b>
                </nz-form-label>
              </nz-form-item>
            </div>
            <div nz-col [nzSpan]="24">
              <nz-radio-group [(ngModel)]="student.localGovernmentCoordination" [ngModelOptions]="{standalone: true}">
                <div nz-row>
                  <div nz-col [nzSpan]="24">
                    <div nz-col [nzSpan]="24">
                      <nz-form-label [nzFor]="'field'" [nzNoColon]="true">
                        <label nz-radio [nzValue]="false">Chưa</label>
                      </nz-form-label>
                    </div>
                    <div nz-col [nzSpan]="24" class="flex">
                      <div>
                        <nz-form-label [nzFor]="'field'" [nzNoColon]="true">
                          <label nz-radio [nzValue]="true">Có (Mức độ):</label>
                        </nz-form-label>
                      </div>
                      <nz-radio-group [(ngModel)]="student.localGovernmentCoordinationId"
                        [ngModelOptions]="{standalone: true}">
                        <div nz-row>
                          <ng-container *ngFor="let localGovernmentCoordinations of listLocalGovernmentCoordinations">
                            <div nz-col [nzSpan]="8">
                              <nz-form-item>
                                <nz-form-label [nzFor]="'field'" [nzNoColon]="true">
                                  <label nz-radio [nzValue]="localGovernmentCoordinations.value"
                                    [nzDisabled]="!student.localGovernmentCoordination">{{
                                    localGovernmentCoordinations.name }}</label>
                                </nz-form-label>
                              </nz-form-item>
                            </div>
                          </ng-container>
                        </div>
                      </nz-radio-group>
                    </div>
                  </div>
                </div>
              </nz-radio-group>
            </div>
          </div>
        </div>
      </div>
    </nz-tab>
    <nz-tab [nzTitle]="'E. QUÁ TRÌNH HỌC TẬP'">
      <div nz-row nzGutter="24" style="padding: 10px;">
        <!-- Table Quá trình học tập-->
        <div nz-col nzSpan="24" class="mt-3">
          <button style="float: right;" class="flex items-center justify-center text-green-600" nz-button
            nzTooltipTitle="Thêm" nzTooltipPlacement="bottom" nz-tooltip (click)="addQTHT()">
            <i nz-icon nzType="plus" nzTheme="outline"></i>
          </button>
        </div>
        <ng-container *ngIf="listQTHT.length > 0">
          <nz-table #Table nzOuterBordered nzShowSizeChanger [nzData]="listQTHT" nzSize="small"
            [nzScroll]="{x: width +'px', y: height + 'px'}" class=" w-full" [nzFrontPagination]="false">
            <thead>
              <tr #pageHeaderTable>
                <th>STT</th>
                <th class="col-head" nzWidth="90px">Năm học</th>
                <th class="col-head" nzWidth="200px">Cơ sở</th>
                <th class="col-head">Tình trạng giáo dục</th>
                <th class="col-head">Lớp học</th>
                <th class="col-head">Giáo viên phụ trách</th>
                <th class="col-head">Chương trình học</th>
                <th class="col-head">Kết quả</th>
                <th class="col-head">Ghi chú</th>
                <th nzRight nzWidth="60px"></th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let data of Table.data; let i = index">
                <td nzLeft>{{ i + 1 }}</td>
                <td>{{data.courseName}}</td>
                <td>{{data.schoolName}}</td>
                <td>{{data.educationalStatusName}}</td>
                <td>{{data.studyingClassYear}}</td>
                <td>{{data.staffName}}</td>
                <td>{{data.chuongTrinhHocName}}</td>
                <td>{{data.resultName}}</td>
                <td>{{data.note}}</td>
                <td nzRight>
                  <div nz-space nzAlign="end" class="space-align-block">
                    <nz-space-item>
                      <a class="text-blue-600" nzTooltipTitle="Sửa" nzTooltipPlacement="top" nz-tooltip
                        (click)="editQTHT(data,i)">
                        <i nz-icon nzType="edit" nzTheme="outline"></i>
                      </a>
                    </nz-space-item>
                    <nz-space-item>
                      <a class="text-red-600" nzTooltipTitle="Xóa" nzTooltipPlacement="top" nz-tooltip
                        (click)="deleteQTHT(i)">
                        <i nz-icon nzType="delete" nzTheme="outline"></i>
                      </a>
                    </nz-space-item>
                  </div>
                </td>
              </tr>
            </tbody>
          </nz-table>
        </ng-container>
        <ng-container *ngIf="listQTHT.length <= 0">
          <nz-table #Table nzOuterBordered nzShowSizeChanger nzSize="small"
            [nzScroll]="{x: width +'px', y: height + 'px'}" class=" w-full" [nzFrontPagination]="false">
            <thead>
              <tr #pageHeaderTable>
                <th>STT</th>
                <th class="col-head" nzWidth="90px">Năm học</th>
                <th class="col-head" nzWidth="200px">Cơ sở</th>
                <th class="col-head">Tình trạng giáo dục</th>
                <th class="col-head">Lớp học</th>
                <th class="col-head">Giáo viên phụ trách</th>
                <th class="col-head">Chương trình học</th>
                <th class="col-head">Kết quả</th>
                <th class="col-head">Ghi chú</th>
                <th nzRight nzWidth="60px"></th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let data of Table.data; let i = index">
                <td nzLeft>{{ i + 1 }}</td>
                <td>{{data.courseName}}</td>
                <td>{{data.schoolName}}</td>
                <td>{{data.educationalStatusName}}</td>
                <td>{{data.studyingClassYear}}</td>
                <td>{{data.staffName}}</td>
                <td>{{data.chuongTrinhHocName}}</td>
                <td>{{data.resultName}}</td>
                <td>{{data.note}}</td>
                <td nzRight>
                  <div nz-space nzAlign="end" class="space-align-block">
                    <nz-space-item>
                      <a class="text-blue-600" nzTooltipTitle="Sửa" nzTooltipPlacement="top" nz-tooltip
                        (click)="editQTHT(data,i)">
                        <i nz-icon nzType="edit" nzTheme="outline"></i>
                      </a>
                    </nz-space-item>
                    <nz-space-item>
                      <a class="text-red-600" nzTooltipTitle="Xóa" nzTooltipPlacement="top" nz-tooltip
                        (click)="deleteQTHT(i)">
                        <i nz-icon nzType="delete" nzTheme="outline"></i>
                      </a>
                    </nz-space-item>
                  </div>
                </td>
              </tr>
            </tbody>
          </nz-table>
        </ng-container>
      </div>
    </nz-tab>
  </nz-tabset>

  <div *nzModalFooter>
    <div *ngIf="!isEditMode">
      <button nz-button (click)="close()">Đóng</button>
      &nbsp;
      <button nz-button nzType="primary" (click)="Update()">Lưu & Thêm</button>
      &nbsp;
      <button nz-button nzType="primary" (click)="UpdateClose()">Lưu & Đóng</button>
    </div>
    <div *ngIf="isEditMode">
      <button nz-button (click)="close()">Đóng</button>
      &nbsp;
      <button nz-button nzType="primary" (click)="UpdateClose()">Sửa</button>
    </div>
  </div>
</form>
